import React from 'react';

import ClassesPage from '../../academyPages/Classes';

function Classes() {
  return <ClassesPage coachMode/>;
}

export default Classes;